import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Formata um valor para moeda em formato brasileiro (R$)
 * 
 * @param {number} value - Valor a ser formatado
 * @returns {string} Valor formatado como moeda brasileira
 */
export function formatCurrency(value: number | undefined): string {
  if (value === undefined || value === null) return "R$ 0,00"
  
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value)
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
